import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import Button from '@material-ui/core/Button'

import Divider from '@material-ui/core/Divider';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import firebase from "gatsby-plugin-firebase"
import "firebase/database"


import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Webcam from 'react-webcam'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";



const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '30rem'
  },
}));

export default function IdModal(props) {
  const modalClasses = useStyles();
  const [open, setOpen] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const [idUrl, setIdUrl] = React.useState("");
  const webcamRefF = React.useRef(null);
  const [scanStatus, setScanStatus] = React.useState("No Scan");
  const [completedStep, setCompletedStep] = React.useState(false)
  const [frontImg , setFrontImg] = React.useState();
  const [rearImg , setRearImg] = React.useState();
  const {classes, uid} = props;

  const webcamRefR = React.useRef(null);

  const captureF = React.useCallback(
    () => {
      const imageSrc = webcamRefF.current.getScreenshot();
      //t(imageSrc)
      setFrontImg(imageSrc);
      setScanStatus("Loading.....")
      
      var db = firebase.database();

      var storageRef = firebase.storage().ref();

      var memberRef = storageRef.child("/MemberProfiles/" + uid + "/ID/");
      var imageRef = memberRef.child("Front.jpg");
      var Member = db.ref('/Members/' + uid + "/ID/");

        imageRef.putString(imageSrc, 'data_url').then((snapshot) => {
        
        snapshot.ref.getDownloadURL().then(url => { Member.update({ front: JSON.stringify(url) }) })
        console.log(`Front uploaded!`)
          
      }).finally(() => {
        setScanStatus("Scan Completed")
        setCompletedStep(true)
      }).catch(err => {console.log(err)})


    },
    [webcamRefF]
  );

  const captureR = React.useCallback(
    () => {
      const imageSrc = webcamRefR.current.getScreenshot();
      
      
      setRearImg(imageSrc)
      
      var db = firebase.database();

      var storageRef = firebase.storage().ref();

      var memberRef = storageRef.child("/MemberProfiles/" + uid + "/ID/");
      var imageRef = memberRef.child("Rear.jpg");
      var Member = db.ref('/Members/' + uid + "/ID/");

        imageRef.putString(imageSrc, 'data_url').then((snapshot) => {
        
        snapshot.ref.getDownloadURL().then(url => { Member.update({ scan: JSON.stringify(url), completed: true }) })
        console.log(`Rear uploaded!`)
          
      }).finally(() => {
        setScanStatus("Scan Completed")
        handleClose()
      }).catch(err => {console.log(err)})
    },
    [webcamRefR]
  );

  
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setStep(1)
  };

  const uploadID = (e) => {
    e.preventDefault();

    var file = e.target.files[0];
        console.log(e.target)

        var db = firebase.database();

        var storageRef = firebase.storage().ref();

        var memberRef = storageRef.child("/MemberProfiles/" + uid + "/ID/");
        var imageRef = memberRef.child(file.name);
        var Member = db.ref('/Members/' + uid + "/ID/");

          imageRef.put(file).then((snapshot) => {
          
          snapshot.ref.getDownloadURL().then(url => { Member.update({ front: JSON.stringify(url) }); setIdUrl(url) })
          console.log(`File ${file.name} uploaded!`)
            
        }).finally(() => {
            
        }).catch(err => {console.log(err)})
        
}

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "environment"
};

const nextStep = (e) => {
    e.preventDefault();
    setStep(2)
    setScanStatus("No Scan")
}

const Step1 = () => {
    return(
        <>
        <Grid item xs={12} sm={12} md={12}>
        <p id="transition-modal-description">Please upload a picture of the front of your ID Card / Driver's License</p>
        <p id="transition-modal-description">Please make sure the picture is clear!</p>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
        <Webcam
        audio={false}
        height='300rem'
        ref={webcamRefF}
        screenshotFormat="image/jpeg"
        width='300rem'
        videoConstraints={videoConstraints}
      />
      <p id="results">{scanStatus}</p>
        </Grid>

        
        <Grid item xs={12} sm={12} md={8} alignContent="space-between">
            
        <Button
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        onClick={e => captureF(e)}
      >
        Scan Front
      </Button>
        <Button
        variant="contained"
        color="primary"
        onClick={e => nextStep(e)}
        disabled={!completedStep}
      >
        Next Step
      </Button>
      </Grid>
        </>
    )
}

const Step2 = () => {
  
    return(
        <>
        <p id="transition-modal-description">Please scan the barcode on your ID</p>
           <div id="barcodeScan">
           <Grid item xs={12} sm={12} md={12}>
           <Webcam
        audio={false}
        height='300rem'
        ref={webcamRefR}
        screenshotFormat="image/jpeg"
        width='300rem'
        videoConstraints={videoConstraints}
      />
               </Grid>
               <p id="results">{scanStatus}</p>
           <Button
        variant="contained"
        color="primary"
        onClick={e => captureR(e)}
      >
        Scan
      </Button>
      
           </div>
        </>
    )
}

  return (
    <div>
      <Button variant="contained" color="primary" component="span" onClick={handleOpen}>
        Verify ID
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={modalClasses.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
        <Paper className={modalClasses.paper}>
          <Grid container spacing={1} >
          <Grid item xs={12} sm={12} md={12}>
            <h2 id="transition-modal-title">Step {step} - {step == 1 ? "Upload picture" : "Scan"}</h2>
            <Divider variant="middle" />
            </Grid>
            <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={12}>
            {step == 1 ? <Step1 /> : <Step2 /> }
            </GridItem>
            </GridContainer>
            </Grid>
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
}
